import React from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import FeedbackListComponent from "../../../components/slider/FeedbackListComponent";
import PageMeta from "../../../components/common/PageMeta";

const FeedbackList = () => {

    return (
        <>
            <PageMeta title="Danh sách feedback" description="Danh sách feedback"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <FeedbackListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default FeedbackList;
